// extracted by mini-css-extract-plugin
export default {"title":"PageNotFound_title__F6MnT","actionButton":"PageNotFound_actionButton__JNwPO"};